/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Receipts_WaitingInputs */

const en_queue_receipts_waiting = /** @type {(inputs: Queue_Receipts_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse receipts to apply`)
};

/**
* | output |
* | --- |
* | "Warehouse receipts to apply" |
*
* @param {Queue_Receipts_WaitingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_receipts_waiting = /** @type {((inputs?: Queue_Receipts_WaitingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Receipts_WaitingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_receipts_waiting(inputs)
});